import { CircleLoader } from 'components/CircleLoader';
import { JobCard } from 'components/common/Job/JobCard';
import { JobCardLargeSize } from 'components/common/Job/JobCardLargeSize';
import { Department } from 'constants/index';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';
import { axiosInstance } from 'services/axios';
import { JobType } from 'types';

import { JobsFilter } from './JobsFilter';
import { JobsFilterMobile } from './JobsFilterMobile';
import { NotFoundJobs } from './NotFoundJobs';


interface Props {
  jobs: JobType[];
  totalNumberOpeningJobs: number;
  departments?: string[];
}

const DEFAULT_LIMIT = 10;

export const ListJobs: React.FC<Props> = ({
  jobs,
  totalNumberOpeningJobs,
  departments = Department
}) => {
  const router = useRouter();
  const [listJobs, setListJobs] = useState<JobType[]>(jobs);
  const [totalCount, setTotalCount] = useState<number>(totalNumberOpeningJobs);
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const handleClearFilter = () => {
    router.replace('/co-hoi-viec-lam', undefined, { shallow: true });
  };

  const fetchJobsByFilter = useCallback(
    async (pageNumber: number) => {
      const apiUrl = 'api/jobs';
      const payload = {
        address: router.query.address
          ? decodeURIComponent(router.query.address.toString()).split(',')
          : [],
        workType: router.query.workType
          ? decodeURIComponent(router.query.workType.toString()).split(',')
          : [],
        department: router.query.department
          ? decodeURIComponent(router.query.department.toString()).split(',')
          : [],
        skill: router.query.skill
          ? decodeURIComponent(router.query.skill.toString()).split(',')
          : [],
        title: router.query.keyword
          ? decodeURIComponent(router.query.keyword.toString())
          : '',
        page: pageNumber,
        limit: DEFAULT_LIMIT
      };
      try {
        const { data } = await axiosInstance.post(apiUrl, payload);
        setTotalCount(data.totalCount);
        setPage(pageNumber);
        if (pageNumber === 1) {
          setListJobs(data.jobs);
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
        return data.jobs;
      } catch (error) {
        console.log(error);
      }
    },
    [router.query]
  );

  useEffect(() => {
    fetchJobsByFilter(1);
  }, [router.query, fetchJobsByFilter]);

  const handleLoadMoreJobs = async () => {
    setLoading(true);
    try {
      const data = await fetchJobsByFilter(page + 1);
      const updateListJobs = [...listJobs].concat(data);
      setListJobs(updateListJobs);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const isShowLoadMoreButton = page * DEFAULT_LIMIT < totalCount;

  return (
    <div className="flex flex-col items-center mb-12 scroll-smooth">
      <div className="block min-[1120px]:hidden sticky top-[56px] z-10 bg-white">
        <JobsFilterMobile
          handleClearFilter={handleClearFilter}
          departments={departments}
        />
      </div>
      <div className="max-w-[1120px] px-4 md:px-0 py-3 w-full">
        <div className="flex">
          <aside
            className="hidden min-[1120px]:block mr-[32px]"
            style={{ contain: 'paint' }}
          >
            <div className="sticky top-[85px]">
              <JobsFilter
                handleClearFilter={handleClearFilter}
                departments={departments}
              />
            </div>
          </aside>
          {listJobs.length > 0 ? (
            <div className="flex flex-col items-center gap-y-4 w-full">
              <div className="flex-col gap-y-8 hidden sm:flex px-0 lg:px-4 w-full">
                {listJobs.map(job => (
                  <JobCardLargeSize key={job.id} job={job} />
                ))}
              </div>
              <div className="flex flex-col gap-y-8 sm:hidden">
                {listJobs.map(job => (
                  <JobCard key={job.id} job={job} />
                ))}
              </div>
              {isShowLoadMoreButton && (
                <button
                  disabled={loading}
                  className="w-[200px] h-[38px] flex justify-center items-center gap-x-2 text-brand-300 font-medium text-base px-[24px] py-[9px] rounded-[41px] border-[1px] border:solid border-brand-300"
                  onClick={handleLoadMoreJobs}
                >
                  {loading ? <CircleLoader color="red" /> : null} Xem thêm
                </button>
              )}
            </div>
          ) : (
            <NotFoundJobs
              recommendJobs={jobs.slice(0, 3)}
              handleClearFilter={handleClearFilter}
            />
          )}
        </div>
      </div>
    </div>
  );
};
